import { Service } from "../types/service";

const SERVICES: Service[] = [
  {
    title: "UI/UX",
    description:
      "We design intuitive, beautiful user experiences that make every interaction effortless and engaging.",
  },
  {
    title: "Web Development ",
    description:
      "We build fast, responsive websites that combine functionality, security, and seamless user experience.",
  },
  {
    title: "App Development",
    description:
      "We develop high-performance mobile apps that are sleek, scalable, and designed for the modern user.",
  },
];

export default SERVICES;
